module.exports = __webpack_public_path__ + "static/media/aboutUs5.709b7c3a.jpg";